export default function handleLink(url) {
  window.open(url, '_blank').focus()
}
